module.exports = {"unknownError":"Etwas ist schief gelaufen","close":"Schließen","myAccount":"Mein Konto","filter":"Filter","paid":"Bezahlt"}